export default __webpack_public_path__ + "static/v2_ilona_bw-0afca49627f70ee137a1a7314fb9f3a1.jpg";